//
//
//
//
//
//
//
//
//



export default {
  name: 'MatchEmpty',
  props: {
    placeholder: {
      type: String,
      default: '暂没数据',
    },
    iconMatchEmpty: {
      type: String,
      default: '/static/images/icons/no_data.png',
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/MatchEmpty.vue